import clsx from "clsx";
import { GripVertical } from "lucide-react";

type DragHandleProps = { isDragging?: boolean };
export const DragHandle = ({ isDragging, ...rest }: DragHandleProps) => {
  return (
    <div
      {...rest}
      className={clsx("mr-2", {
        "cursor-grabbing": isDragging,
      })}
    >
      <GripVertical className="h-4" />
    </div>
  );
};
